import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Login from '@/pages/Login'
import NotFound from '@/pages/NotFound'
import PublicLayout from '@/pages/Layouts/PublicLayout'
import ResetPassword from '@/pages/ResetPassword'  
import RequireAuth from '@/middlewares/RequireAuth'
import MainLayout from './pages/Layouts/MainLayout' 
import Home from './pages/Home'
import MasterDataProduct from './pages/MasterData/Product'
import MasterDataResale from './pages/MasterData/Resale'
import MasterDataPDV from './pages/MasterData/PDV'
import User from './pages/Access/User'
import UserPermissions from '@/pages/Access/UserPermissions'
import MarketResearch from './pages/MarketResearch'
import MarketResearchSettings from './pages/MarketResearch/Settings'
import MarketResearchDetails from './pages/MarketResearch/Details'
import MapComponent from './pages/MarketResearch/Details/components/Map'

const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<PublicLayout />}>
                    <Route path="*" element={<NotFound />} />
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/recuperar-senha"
                        element={<ResetPassword />}
                    />
                </Route>
                <Route element={<MainLayout />}>
                    <Route
                        path="/" 
                        element={
                            <RequireAuth isAllowed>
                                <Home />
                            </RequireAuth>
                        }
                    > 
                    </Route> 
                    <Route path="market-research" >
                        <Route
                            element={
                                <RequireAuth isAllowed>
                                    <MarketResearch />
                                </RequireAuth>
                            }
                            index
                        />  
                        <Route
                            path="map"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <MapComponent />  
                                </RequireAuth>
                            }
                        />   
                        <Route
                            path="settings"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <MarketResearchSettings />  
                                </RequireAuth>
                            }
                        />  
                        <Route
                            path="details"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <MarketResearchDetails />  
                                </RequireAuth>
                            }
                        />   
                    </Route>  
                    <Route path="masterdata">  
                        <Route
                            path="product"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <MasterDataProduct />  
                                </RequireAuth>
                            }
                        />  
                        <Route
                            path="resale"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <MasterDataResale />  
                                </RequireAuth>
                            }
                        />  
                        <Route
                            path="pdv"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <MasterDataPDV />  
                                </RequireAuth>
                            }
                        />  
                    </Route>
                    <Route path="access">  
                        <Route
                            path="user"
                            element={ 
                                <RequireAuth isAllowed> 
                                    <User />  
                                </RequireAuth>
                            }
                        />  
                        <Route
                            path='user-permissions'
                            element={
                                <RequireAuth isAllowed> 
                                    <UserPermissions />  
                                </RequireAuth>
                            }
                        />
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default Router
